// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { ImageModel } from "@insite/client-framework/Types/ApiModels";
import Button, { ButtonIcon, ButtonProps } from "@insite/mobius/Button";
import Clickable from "@insite/mobius/Clickable";
// import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer"; // bunzl custom code
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import ChevronDown from "@insite/mobius/Icons/ChevronDown";
import ChevronLeft from "@insite/mobius/Icons/ChevronLeft";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import ChevronUp from "@insite/mobius/Icons/ChevronUp";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import { injectCss } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import useEmblaCarousel from "embla-carousel-react";
// import React, { useEffect, useState } from "react"; // bunzl custom code
import { connect } from "react-redux";
import styled, { css } from "styled-components";

/* Store Custom Code - Start */
import usePrevious from "@insite/client-framework/Common/Hooks/usePrevious";
import translate from "@insite/client-framework/Translate";
import CarouselButton, {
    CarouselButtonPresentationProps,
} from "@store/Library/Components/Toolkit/Carousel/CarouselButton";
import GridContainer, { GridContainerProps } from "@store/MobiusOverrides/GridContainer/GridContainer";
import useMergeProps from "@toolkit/Framework/Common/Hooks/useMergeProps";
import getProductVideoUrl from "@toolkit/Framework/Common/Utilities/getProductVideoUrl";
import React, { useEffect, useMemo, useState } from "react";
/* Store Custom Code - End */

interface OwnProps {
    scrollingBehavior?: string;
    numberOfVisibleThumbnails?: number;
    selectedIndex?: number;
    onSelectImage?: (index: number) => void;
    extendedStyles?: ProductImageCarouselStyles;
}

const mapStateToProps = (state: ApplicationState) => ({
    productSettings: getSettingsCollection(state).productSettings,
});

type Props = OwnProps & HasProductContext & ReturnType<typeof mapStateToProps>;

export interface ProductImageCarouselStyles {
    mainContainer?: GridContainerProps;
    prevArrowGridItem?: GridItemProps;
    prevArrowButton?: ButtonProps;
    carouselGridItem?: GridItemProps;
    carouselWrapper?: InjectableCss;
    carouselContainer?: InjectableCss;
    /** @deprecated Use CarouselSlideContainer object instead. */
    carouselSlidesContainer?: InjectableCss;
    /** @deprecated Use CarouselSlide object instead. */
    carouselSlide?: InjectableCss;
    carouselSlideInner?: InjectableCss;
    image?: LazyImageProps;
    selectedImage?: LazyImageProps;
    nextArrowGridItem?: GridItemProps;
    nextArrowButton?: ButtonProps;
    verticalPrevArrowGridItem?: GridItemProps;
    verticalCarouselGridItem?: GridItemProps;
    verticalNextArrowGridItem?: GridItemProps;
    // Store Custom Code
    CarouselSlideContainer?: InjectableCss;
    playButton?: CarouselButtonPresentationProps;
}

const getImageCss = (borderColor: string) => css`
    width: 100%;
    height: 100%;
    padding: 1px;
    border: 1px solid ${getColor(borderColor)};
    cursor: pointer;
    justify-content: flex-start;
    // bunzl custom code - changed thumbnail size to be consistent
    img {
        width: 100px;
        height: 100px;
        object-fit: cover;
        padding: 0px;
    }
`;

export const productImageCarouselStyles: ProductImageCarouselStyles = {
    mainContainer: {
        css: css`
            width: auto;
            /* Bunzl Custom Code */
            height: ${pxToRem(100)};
            align-items: center;
            justify-content: center;
            align-self: center;
        `,
    },
    prevArrowGridItem: {
        width: 1,
        align: "middle",
        css: css`
            justify-content: flex-end;
        `,
    },
    verticalPrevArrowGridItem: {
        width: 12,
        align: "middle",
        css: css`
            justify-content: center;
        `,
    },
    prevArrowButton: {
        variant: "secondary",
        color: "text.main",
        css: css`
            border: 0;
            padding: 0;
        `,
    },
    carouselGridItem: { width: 10 },
    verticalCarouselGridItem: { width: 12 },
    carouselWrapper: {
        css: css`
            width: 100%;
        `,
    },
    carouselContainer: {
        css: css`
            overflow: hidden;
        `,
    },
    carouselSlideInner: {
        css: css`
            width: 100%;
            text-align: center;
            position: relative;
            /* Bunzl Custom Code */
            padding: 0;
            display: flex;
            justify-content: center;
        `,
    },
    image: {
        /* Store Custom Code */
        css: getImageCss("common.borderLight"),
    },
    selectedImage: {
        css: css`
            /* bunzl custom code */
            ${getImageCss("primary")}
            border-width: 2px;
            padding: 0px;
        `,
    },
    nextArrowGridItem: {
        width: 1,
        align: "middle",
        css: css`
            justify-content: flex-start;
        `,
    },
    verticalNextArrowGridItem: {
        width: 12,
        align: "middle",
        css: css`
            justify-content: center;
        `,
    },
    nextArrowButton: {
        variant: "secondary",
        color: "text.main",
        css: css`
            border: 0;
            padding: 0;
        `,
    },
};
/* Store Custom Code - Start */
export const CarouselSlidesContainer = styled.div<
    InjectableCss & { isVertical: boolean; numberOfVisibleThumbnails: number }
>`
    display: flex;
    flex-direction: ${props => (props.isVertical ? "column" : "row")};
    align-items: center;
    ${props => (props.isVertical ? `height: ${props.numberOfVisibleThumbnails * 112}px;` : ``)}
    ${props => (props.isVertical ? `min-height: 250px;` : ``)}
    ${injectCss};
`;
/* Store Custom Code - End */

export const CarouselSlide = styled.div<InjectableCss & { numberOfVisibleThumbnails: number }>`
    flex: 0 0 ${props => 100 / props.numberOfVisibleThumbnails}%;
    padding: 0;
    position: relative;
    ${injectCss};
`;

const ProductImageCarousel = ({
    productSettings,
    productContext,
    scrollingBehavior,
    numberOfVisibleThumbnails = 6,
    selectedIndex,
    onSelectImage,
    extendedStyles,
}: Props) => {
    // Store Custom Code
    const styles = useMergeProps(productImageCarouselStyles, extendedStyles);

    const { product } = productContext;
    /* Store Custom Code - Start */
    const previousIndex = usePrevious(selectedIndex) ?? 0;
    const imagesWithoutSizeChart = useMemo(
        () => product?.images?.filter(image => !image.name.toLocaleLowerCase().includes("sizechart")) ?? [],
        [product?.images?.length],
    );
    const imageClickHandler = (index: number) => {
        onSelectImage?.(index);
    };

    useEffect(() => {
        if (
            selectedIndex !== undefined &&
            selectedIndex !== previousIndex &&
            imagesWithoutSizeChart.length > numberOfVisibleThumbnails
        ) {
            if (
                selectedIndex === previousIndex + 1 ||
                (previousIndex === imagesWithoutSizeChart.length - 1 && selectedIndex === 0)
            ) {
                embla?.scrollNext();
            } else if (
                selectedIndex === previousIndex - 1 ||
                (previousIndex === 0 && selectedIndex === imagesWithoutSizeChart.length - 1)
            ) {
                embla?.scrollPrev();
            } else {
                embla?.scrollTo(selectedIndex);
            }
        }
    }, [selectedIndex]);
    /* Store Custom Code - End */

    const isVertical = scrollingBehavior === "vertical";
    const mainContainerStyles = isVertical
        ? styles.mainContainer
        : {
              ...styles.mainContainer,
              css: css`
                  align-items: flex-start;
                  /* bunzl custom code moved so that extended styles can overwrite align-items */
                  ${styles.mainContainer?.css}
              `,
          };
    const [emblaRef, embla] = useEmblaCarousel({
        axis: isVertical ? "y" : "x",
    });
    const [canScrollPrev, setCanScrollPrev] = useState(false);
    const [canScrollNext, setCanScrollNext] = useState(false);
    const setCanScroll = () => {
        setCanScrollPrev(!!embla && embla.canScrollPrev());
        setCanScrollNext(!!embla && embla.canScrollNext());
    };

    useEffect(() => {
        if (!embla || !product.images) {
            return;
        }

        embla.reInit({
            align: product.images.length > numberOfVisibleThumbnails || isVertical ? "start" : "center",
            /* Bunzl Deleted Code */
            axis: isVertical ? "y" : "x",
            /* Store Custom Code - Start */
            loop: true,
            containScroll: "trimSnaps",
            /* Store Custom Code - End */
        });
        setCanScroll();
        /* Store Custom Code - added product.images as a dependency */
    }, [embla, product?.images, scrollingBehavior, numberOfVisibleThumbnails]);

    const getProductImageThumbPath = (productImage: ImageModel) => {
        if (productImage.imageType === "Static") {
            return productImage.smallImagePath || productImage.mediumImagePath;
        }
        if (productImage.imageType === "360" && productSettings.imageProvider === "SIRV") {
            return productImage.mediumImagePath + (productImage.mediumImagePath.indexOf("?") > 0 ? "&thumb" : "?thumb");
        }
        return "";
    };

    if (!product || !product.images || product.images?.length === 0) {
        return null;
    }
    /* Store Custom Code - Added classnames */
    return (
        <GridContainer {...mainContainerStyles} key={product.id} className="product-image-carousel-main-container">
            <GridItem
                {...(isVertical ? styles.verticalPrevArrowGridItem : styles.prevArrowGridItem)}
                className="product-image-carousel-prev-arrow-grid-item"
            >
                {product.images.length > numberOfVisibleThumbnails && (
                    <Button
                        {...styles.prevArrowButton}
                        onClick={() => embla && embla.scrollPrev()}
                        disabled={!canScrollPrev}
                        className="product-image-carousel-prev-arrow-button"
                    >
                        <ButtonIcon src={isVertical ? ChevronUp : ChevronLeft} />
                    </Button>
                )}
            </GridItem>
            <GridItem
                {...(isVertical ? styles.verticalCarouselGridItem : styles.carouselGridItem)}
                className="product-image-thumbnail-carousel-grid-item"
            >
                <StyledWrapper {...styles.carouselWrapper} className="product-image-thumbnail-carousel-wrapper">
                    <StyledWrapper
                        {...styles.carouselContainer}
                        ref={emblaRef}
                        className="product-image-thumbnail-carousel-container"
                    >
                        <CarouselSlidesContainer
                            isVertical={isVertical}
                            numberOfVisibleThumbnails={numberOfVisibleThumbnails}
                            // Store Custom Code
                            {...styles.CarouselSlideContainer}
                            className="product-image-thumbnail-carousel-slides-container"
                        >
                            {/* Store Custom Code - using filtered images */}
                            {imagesWithoutSizeChart.map((productImage, index) => {
                                const videoUrl = getProductVideoUrl(product, productImage.id);
                                return (
                                    <CarouselSlide
                                        key={productImage.id}
                                        numberOfVisibleThumbnails={numberOfVisibleThumbnails}
                                        className="product-image-thumbnail-carousel-slide"
                                    >
                                        <StyledWrapper
                                            {...styles.carouselSlideInner}
                                            className="product-image-thumbnail-carousel-slide-inner"
                                        >
                                            <Clickable
                                                onClick={() => imageClickHandler(index)}
                                                className="product-image-carousel-clickable"
                                            >
                                                <LazyImage
                                                    {...(index === selectedIndex ? styles.selectedImage : styles.image)}
                                                    src={getProductImageThumbPath(productImage)}
                                                    altText={productImage.imageAltText}
                                                    className="product-image-thumbnail-carousel-lazy-image"
                                                />
                                                {videoUrl ? (
                                                    <CarouselButton
                                                        {...styles.playButton}
                                                        label={translate("Play the video")}
                                                        tabIndex={-1}
                                                        aria-hidden="true"
                                                    />
                                                ) : null}
                                            </Clickable>
                                        </StyledWrapper>
                                    </CarouselSlide>
                                );
                            })}
                        </CarouselSlidesContainer>
                    </StyledWrapper>
                </StyledWrapper>
            </GridItem>
            <GridItem
                {...(isVertical ? styles.verticalNextArrowGridItem : styles.nextArrowGridItem)}
                className="product-image-thumbnail-carousel-next-arrow-grid-item"
            >
                {product.images.length > numberOfVisibleThumbnails && (
                    <Button
                        {...styles.nextArrowButton}
                        onClick={() => embla && embla.scrollNext()}
                        disabled={!canScrollNext}
                        className="product-image-thumbnail-carousel-next-arrow-button"
                    >
                        <ButtonIcon src={isVertical ? ChevronDown : ChevronRight} />
                    </Button>
                )}
            </GridItem>
        </GridContainer>
    );
};

/* Store Custom Code - Start */
export const defaultProductImageCarouselCss = `
.product-image-thumbnail-carousel-main-container {
}
.product-image-thumbnail-carousel-prev-arrow-grid-item {
}
.product-image-thumbnail-carousel-prev-arrow-button {
}
.product-image-thumbnail-carousel-grid-item {
}
.product-image-thumbnail-carousel-wrapper {
}
.product-image-thumbnail-carousel-container {
}
.product-image-thumbnail-carousel-slides-container {
}
.product-image-thumbnail-carousel-slide {
}
.product-image-thumbnail-carousel-slide-inner {
}
.product-image-thumbnail-carousel-clickable {
}
.product-image-thumbnail-carousel-lazy-image {
}
.product-image-thumbnail-carousel-next-arrow-grid-item {
}
.product-image-thumbnail-carousel-next-arrow-button {
}
`;
/* Store Custom Code - End */
export default connect(mapStateToProps)(withProductContext(ProductImageCarousel));
